/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_SALES_RETURN_SUCCESS,
  LOAD_SALES_RETURN_ERROR,
  LOAD_SALES_RETURN_SEARCH_IMEI_BARCODE_SUCCESS,
  LOAD_SALES_RETURN_SEARCH_IMEI_BARCODE_ERROR,
  LOAD_RECORDS_VALID_CACHE,
  LOAD_SALES_RETURN_RECORDS_META_DATA_SUCCESS,
  LOAD_SALES_RETURN_RECORDS_META_DATA_ERROR,
  CREATE_SALES_RETURN_SUCCESS,
  CREATE_SALES_RETURN_ERROR,
  UPDATE_SALES_RETURN_SUCCESS,
  UPDATE_SALES_RETURN_ERROR,
  DELETE_SALES_RETURN_SUCCESS,
  DELETE_SALES_RETURN_ERROR,
  LOAD_SALES_RETURN_CATEGORY_SUCCESS,
  LOAD_SALES_RETURN_CATEGORY_ERROR,
  CREATE_SALES_RETURN_PARTIES_CATEGORY_SUCCESS,
  CREATE_SALES_RETURN_PARTIES_CATEGORY_ERROR,
  LOAD_PARTIES_TRANSACTION_SUCCESS,
  LOAD_PARTIES_TRANSACTION_ERROR,
  LOAD_PARTY_VENDOR_ADDRESS_SUCCESS,
  LOAD_PARTY_VENDOR_ADDRESS_ERROR,
  CREATE_PARTY_VENDOR_ADDRESS_SUCCESS,
  CREATE_PARTY_VENDOR_ADDRESS_ERROR,
  LOAD_SALES_RETURN_DASHBOARD_TRANSACTION_SUCCESS,
  LOAD_SALES_RETURN_DASHBOARD_TRANSACTION_ERROR,
  LOAD_SALES_RETURN_TOTAL_SUCCESS,
  LOAD_SALES_RETURN_TOTAL_ERROR,
  LOAD_RETURN_TOTAL_SALES_PAID_SUCCESS,
  LOAD_RETURN_TOTAL_SALES_PAID_ERROR,
  LOAD_RETURN_TOTAL_SALES_UNPAID_SUCCESS,
  LOAD_RETURN_TOTAL_SALES_UNPAID_ERROR,
} from "./constants";

const initialState = {
  sales_invoice_list: [],
  search_imei_barcode: [],
  dashboard_transactions: [],
  sales_total_list: [],
  total_paid_list: [],
  total_unpaid_list: [],
  parties_collect_list: [],
  parties_pay_list: [],
  category_list: [],
  party_address_list: [],
  parties_transaction_list: [],
  record: {},
  records: {},
  recordsMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    sales_invoice_list,
    search_imei_barcode,
    dashboard_transactions,
    sales_total_list,
    total_paid_list,
    total_unpaid_list,
    party_address_list,
    category_list,
    parties_transaction_list,
    record,
    recordsMetaData = {},
    error,
    success,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_SALES_RETURN_SUCCESS:
        draft.sales_invoice_list = sales_invoice_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_SALES_RETURN_SEARCH_IMEI_BARCODE_SUCCESS:
        draft.search_imei_barcode = search_imei_barcode;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_SALES_RETURN_DASHBOARD_TRANSACTION_SUCCESS:
        draft.dashboard_transactions = dashboard_transactions;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_SALES_RETURN_TOTAL_SUCCESS:
        draft.sales_total_list = sales_total_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_RETURN_TOTAL_SALES_PAID_SUCCESS:
        draft.total_paid_list = total_paid_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_RETURN_TOTAL_SALES_UNPAID_SUCCESS:
        draft.total_unpaid_list = total_unpaid_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PARTY_VENDOR_ADDRESS_SUCCESS:
        draft.party_address_list = party_address_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_SALES_RETURN_CATEGORY_SUCCESS:
        draft.category_list = category_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_SALES_RETURN_PARTIES_CATEGORY_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case LOAD_PARTIES_TRANSACTION_SUCCESS:
        draft.parties_transaction_list = parties_transaction_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_SALES_RETURN_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case CREATE_PARTY_VENDOR_ADDRESS_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case UPDATE_SALES_RETURN_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.error = false;
        draft.success = success;
        break;
      case DELETE_SALES_RETURN_SUCCESS:
        draft.record = record;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_SALES_RETURN_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_SALES_RETURN_ERROR:
      case LOAD_SALES_RETURN_CATEGORY_ERROR:
      case LOAD_PARTY_VENDOR_ADDRESS_ERROR:
      case CREATE_SALES_RETURN_PARTIES_CATEGORY_ERROR:
      case CREATE_PARTY_VENDOR_ADDRESS_ERROR:
      case LOAD_PARTIES_TRANSACTION_ERROR:
      case LOAD_SALES_RETURN_DASHBOARD_TRANSACTION_ERROR:
      case LOAD_SALES_RETURN_TOTAL_ERROR:
      case LOAD_RETURN_TOTAL_SALES_UNPAID_ERROR:
      case LOAD_RETURN_TOTAL_SALES_PAID_ERROR:
      case CREATE_SALES_RETURN_ERROR:
      case UPDATE_SALES_RETURN_ERROR:
      case DELETE_SALES_RETURN_ERROR:
      case LOAD_SALES_RETURN_SEARCH_IMEI_BARCODE_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      case LOAD_SALES_RETURN_RECORDS_META_DATA_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
